// import { useMemo } from 'react';
// import { useLocation } from 'react-router-dom';

// const useApp = () => {
//   const location = useLocation();

//   const currentMenuNameFullScreen = useMemo(() => {
//     return location.pathname;
//   }, [location.pathname]);
//   return { currentMenuNameFullScreen };
// };

// export default useApp;

import { useMemo } from "react";
import { useLocation, matchPath } from "react-router-dom";

const useApp = () => {
  const location = useLocation();

  const currentMenuNameFullScreen = useMemo(() => {
    const pathname = location.pathname;

    if (matchPath("/order/list/edit/:id", pathname)) {
      return "/order/list/edit/:id";
    }
    if (matchPath("/order/list/sentToManager/edit/:id", pathname)) {
      return "/order/list/sentToManager/edit/:id";
    }

    if (matchPath("/order/list/view/:id", pathname)) {
      return "/order/list/view/:id";
    }

    if (matchPath("/order/list/price/admin/edit/:id", pathname)) {
      return "/order/list/price/admin/edit/:id";
    }

    if (matchPath("/order/list/set/price/edit/:id", pathname)) {
      return "/order/list/set/price/edit/:id";
    }

    if (matchPath("/order/list/set/price/list/:id", pathname)) {
      return "/order/list/set/price/list/:id";
    }

    return pathname;
  }, [location.pathname]);

  return { currentMenuNameFullScreen };
};

export default useApp;

